import React, { useEffect, useLayoutEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhatWeDo from "./components/WhatWeDo";
import ProblemConsultations from "./components/ProblemConsultations";
import GameChanger from "./components/GameChanger";
import SmileRevealSeconds from "./components/SmileRevealSeconds";
import SimpleFast from "./components/SimpleFast";
import HowPracticesUse from "./components/HowPracticesUse";
import Pricing from "./pages/Pricing";
import PricingPlans from "./components/PricingPlans";
import CaseAcceptanceIncrease from "./components/CaseAcceptanceIncrease";
import LeadMachine from "./components/LeadMachine";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import ReadyToSeeDifference from "./components/ReadyToSeeDifference";

import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Tos from "./pages/Tos";
import Hipaa from "./pages/Hipaa";
import SEO from "./components/SEO";

const Home = () => {
  return (
    <>
      <SEO
        title="Home"
        description="SmileReveal™ is an AI-powered smile simulation tool that turns uncertainty into excitement instantly. Increase your dental case acceptance rates by up to 60%."
      />
      <div
        className="relative"
        style={{
          backgroundImage: "url('/svgs/background.svg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Hero />

        {/* Gradient fade at bottom */}
        <div className="pointer-events-none absolute bottom-0 left-0 w-full h-32 bg-gradient-to-b from-transparent to-white backdrop-blur-0 z-40"></div>
      </div>

      <GameChanger />
      <CaseAcceptanceIncrease />
      <LeadMachine />
      <WhatWeDo />
      <ProblemConsultations />
      <SmileRevealSeconds />
      <SimpleFast />
      <PricingPlans />
      <HowPracticesUse />
      <ReadyToSeeDifference />
      <FAQ />
      <Footer />
    </>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!("scrollRestoration" in window.history)) {
      return undefined;
    }

    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/tos" element={<Tos />} />
        <Route path="/hipaa" element={<Hipaa />} />
      </Routes>
    </Router>
  );
}

export default App;
